module.exports = __webpack_public_path__ + "static/media/mikrotik.27280cd5.png";